import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { FC, RefObject } from "react";
import { useTranslation } from "react-i18next";

import { useRtl } from "@ryde/redux";

interface IRideStationBulkBackButtonProps {
  buttonRef: RefObject<HTMLButtonElement>;
  onClick: () => void;
}

export const RideStationBulkBackButton: FC<IRideStationBulkBackButtonProps> = ({
  buttonRef,
  onClick,
}) => {
  const { t } = useTranslation();
  const { isRtl } = useRtl();

  return (
    <button
      ref={buttonRef}
      type="button"
      className="bulk_back_button"
      onClick={onClick}
      aria-label={t("ride.BULK_ACTION_BACK_TO_MENU")}
    >
      {!isRtl && <ArrowBack />}
      {isRtl && <ArrowForward />}
    </button>
  );
};
